<template>
  <el-container>
    <el-aside style="width: 10.8vw" v-show="isLogin">
      <el-menu class="sideMenu" :default-active="$route.path" @select="handleselect">
        <el-menu-item index="/zzc/jianjie">中转仓简介</el-menu-item>
        <el-menu-item index="/zzc/zzcOrders">中转订单明细</el-menu-item>
        <el-menu-item index="/zzc/prices">中转仓价格表</el-menu-item>
        <el-menu-item index="/zzc/claim">理赔列表</el-menu-item>
      </el-menu>
      <!-- </div> -->

      <div class="fixed-bottom">重要通知<br><img :src="xtgg" class="xtgg_img" @click="xtgg_view()" /></div>
    </el-aside>
    <el-main v-show="isLogin">
      <router-view></router-view>
    </el-main>
    <!-- 公告弹出框 -->
    <el-dialog
      :visible.sync="xtgg_dialogFormVisible"
      style="text-align: center; width: 100%; height: 120%; overflow-y: auto"
      title="2026-02-28 抖音同步单 上线通知"
    >
      <el-form
        style="
          width: 100%;
          height: 100%;
          text-align: left;
        "
      >
        <el-form-item>
          <div style="background-color: #f7f8fb; padding-left: 20px;padding-right: 20px; border-radius: 0.6em;">
            <span style="font-weight:bold;font-size:18px;color:red;">抖音同步单， 解析地址注意事项</span><br />
            <span>
              <img src="@/assets/dytbd.png" alt="Image" style="width: 100%" />
            </span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import Cookies from "js-cookie";
import xtgg from "../xtgg/index.vue";

export default {
  name: "zzc",
  components: {
    xtgg,
  },
  data() {
    return {
      isLogin: true,
      wx_image: require("@/assets/kssh.png"),
      xtgg: require("@/assets/xtgg.jpg"),
      xtgg_dialogFormVisible:false,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    // const userToken = Cookies.get("view_userToken");

    // if (userToken == undefined) {
    //   this.isLogin = false;
    //   this.$confirm("请先登录再使用！", "提示", {
    //     confirmButtonText: "确定",
    //   })
    //     .then(() => {
    //       // 重新导航到登录页面
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/" });
    //     });
    //   return;
    // } else {
    //   this.isLogin = true;
    // }
    if (this.$route.path == "/zzc") {
      this.handleselect("/zzc/jianjie");
    }
  },
  methods: {
    handleselect(path) {
      this.$router.push(path);
    },
    xtgg_view(){
      this.xtgg_dialogFormVisible = true;
    }
  },
};
</script>

<style scoped>
.el-container {
  background-color: rgb(247, 248, 252);
  height: 90vh;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  display: none; /* 针对Chrome, Safari和Opera */
}
.el-side {
  width: 11vw;
  height: 90vh;
}
.el-main {
  height: 89vh;
  margin-top: 1.5vh;
  float: right;
  background-color: white;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
}
.sidebar-nav {
  width: 10vw;
  height: 31vh;
  background-color: white;
  border-radius: 0.6em;
  margin-left: 0.8vw;
  margin-top: 1.5vh;
  text-align: left;
}
.sideMenu {
  text-align: left;
  width: 10vw;
  /* height: 31vh; */
  background-color: white;
  margin-left: 15px;
  margin-top: 1.5vh;
  font-weight: bold;
  border-radius: 0.6em;
}
.sideMenu .el-menu-item {
  color: rgb(110, 110, 110);
  border-radius: 0.6em;
  margin: 10px 15px;
  height: 42px;
  line-height: 42px;
}

/* //一定要添加！important提高优先级 */
.el-menu-item.is-active {
  /* //设置背景颜色 */
  background-color: #0850fc !important;
  /* //设置字体颜色 */
  color: white !important;
}
.xtgg_img {
  width: 80px;
}
.fixed-bottom {
  position: absolute; /* 或者使用 fixed，取决于是否需要跟随滚动 */
  bottom: 20px;
  color: red;
  font-size: 20px;
  left: 20px;
}
</style>
<style>
.el-dialog__title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/zzc/index.vue